module.exports = __webpack_public_path__ + "static/soc1-a7d7ac90cccec526071a1930e29dc35e.png";